export default __webpack_public_path__ + "static/media/calendar.fcb59f66.png";